<script>
import UserTeamMultiselect from 'dashboard/components/UserTeamMultiselect.vue';

export default {
  components: {
    UserTeamMultiselect,
  },
  props: {
    modelValue: { type: Object, default: () => ({}) },
    placeholder: { type: String, default: '' },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      userIds: [],
      teamIds: [],
    };
  },
  mounted() {
    const { user_ids: userIds = [], team_ids: teamIds = [] } =
      this.modelValue || {};
    this.userIds = [...userIds];
    this.teamIds = [...teamIds];
  },
  methods: {
    updateValue() {
      this.$emit('update:modelValue', {
        user_ids: this.userIds,
        team_ids: this.teamIds,
      });
    },
    onUserIdsChange(value) {
      this.userIds = value;
      this.updateValue();
    },
    onTeamIdsChange(value) {
      this.teamIds = value;
      this.updateValue();
    },
  },
};
</script>

<template>
  <UserTeamMultiselect
    :user-ids="userIds"
    :team-ids="teamIds"
    :placeholder="placeholder"
    @update:user-ids="onUserIdsChange"
    @update:team-ids="onTeamIdsChange"
  />
</template>
